import ApplicationModel, { attr } from '../ApplicationModel';
import { type UserRestrictionOverrideAttributes } from './generated/UserRestrictionOverrideAttributes';
import { model } from '../modelBuilder';

interface UserRestrictionOverride extends UserRestrictionOverrideAttributes {}

@model
class UserRestrictionOverride extends ApplicationModel {
  // Start auto-generated
  static typename: 'UserRestrictionOverride' = 'UserRestrictionOverride';
  get typename(): 'UserRestrictionOverride' {
    return 'UserRestrictionOverride';
  }

  static internalTypename: 'UserRestrictionOverride' =
    'UserRestrictionOverride';
  get internalTypename(): 'UserRestrictionOverride' {
    return 'UserRestrictionOverride';
  }

  static inputType = 'UserRestrictionOverrideAttributes!';

  static filterType = 'UserRestrictionOverrideFilters!';
  static filters = { record: 'HasAccessRestrictionsRecordInput!' };

  static fields = {
    access: attr({ writable: true, readable: true }),
    createdAt: attr({ readable: true }),
    id: attr({ readable: true }),
    maxAccess: attr({ readable: true }),
    updatedAt: attr({ readable: true }),
    userId: attr({ readable: true }),
    record: attr.belongsTo({
      writeShape: ['id', 'typename'],
      readable: true,
      typename: ['Page'],
    }),
    user: attr.belongsTo({
      writeShape: ['id', 'name', 'email'],
      readable: true,
      typename: 'User',
    }),
  };
  // End auto-generated
}

export default UserRestrictionOverride;
